import getNormalizedError from './getNormalizedError'
import makeContent from './makeContent'

/**
 * A kapott bemeneti adatból egy html struktúrát gyárt.
 * @param data - Az adat, amiből a hibakiírást kell gyártani.
 */
export default function makeRuntimeErrorContent (data: unknown): HTMLElement {
  const err = getNormalizedError(data)

  return makeContent(err.message, err.stack)
}
